import gql from 'graphql-tag'

export const MyPerm = gql`
  query MyPerm {
    MyPerm {
      success
      message
    }
  }
`

export const GET_WITHHOLDING_TAX = gql`
  query withholdingTaxList {
    withholdingTaxList {
      success
      message
      data {
        id
        value
        createdAt
        updatedAt
      }
    }
  }
`
export const TIRE_PATCH_LIST = gql`
 query TirePatchLogList(
  $limit: Int
  $offset: Int
  $status: FilterTirePatchLogStatus
  $location: String
  $fullname: String
  $serialNumber: String
  $orderField: TirePatchLogOrderField
  $orderBy: OrderBy
  $CreatedBy: String
  $address: String
  $refId: String
 ) {
  TirePatchLogList(input:{
    limit: $limit
    offset: $offset
    status: $status
    location: $location
    orderField: $orderField
    orderBy: $orderBy
    driver: {
      fullname: $fullname
    }
    serial: {
      serialNumber: $serialNumber
    }
    CreatedBy: $CreatedBy
    address: $address
    refId: $refId
  }) {
    lists {
      id
      patchDate
      status
      Driver{
        id
        fullname
      }
      TirePatchStore{
        id
        name
        phoneNumber
        address
        taxId
      }
      Serial{
        id
        serialNumber
        inventoryOption{
          id
          variantName
        }
      }
      CreatedBy{
        userId
        firstname
        lastname
      }
      refId
    }
    totalCount
    totalFilter
  }
 }
`

export const PURCHASE_REQUISITION_LIST_FOR_PO = gql`
  query PurchaseRequestListInPO (
    $id: Int
    $refId: String
    $deadlineDate: Date
    $remark: String
    $repairId: Int
    $createdAt: Date
    $updatedAt: Date
    $orderBy: OrderBy
    $orderField: PurchaseRequestOrderField
    $limit: Int
    $offset: Int
    $RepairJob: FilterRepairJob
    $RequestBy: FilterByRequestBy
    $status: PurchaseRequestStatusALL
    $supplierId: Int
  ) {
    PurchaseRequestListInPO(input:{
      id: $id
      refId: $refId
      deadlineDate: $deadlineDate
      remark: $remark
      repairId: $repairId
      createdAt: $createdAt
      updatedAt: $updatedAt
      orderBy: $orderBy
      orderField: $orderField
      limit: $limit
      offset: $offset
      RepairJob: $RepairJob
      RequestBy: $RequestBy
      status: $status
      supplierId: $supplierId
    }) {
      lists {
        id
        refId
        deadlineDate
        remark
        repairId
        status
        Items {
          id
          inventoryOptionId
          InventoryOption {
            id
            sku
            buyPrice
            salesPrice
            isVat
            vat
            initialStock
            minimumStock
            variantName
            inventory{
              id
              sku
              reference
              barcode
              productName
              productGroup
              stockable
              stockType
              category
              brand
              initialCost
              variantAmount
              sellable
              purchasable
              taxable
              serialTracking
              status
              model
              unit
            }
            initialCost
            stockLocation{
              id
              quantity
              warehouse{
                id
                warehouseCode
              }
            }
            url
          }
          requestId
          quantity
          orderedQuantity
          createdAt
          updatedAt
        }
        RepairJob {
          id
          refId
        }
        RequestBy {
          userId
          firstname
          lastname
          telephone
          position
          Warehouses {
            id
            warehouseCode
            warehouseName
          }
        }
        createdAt
        updatedAt
      }
      totalCount
      totalFilter
    }
  }
`

export const PURCHASE_REQUISITION_LIST = gql`
  query PurchaseRequestList (
    $id: Int
    $refId: String
    $deadlineDate: Date
    $remark: String
    $repairId: Int
    $createdAt: Date
    $updatedAt: Date
    $orderBy: OrderBy
    $orderField: PurchaseRequestOrderField
    $limit: Int
    $offset: Int
    $RepairJob: FilterRepairJob
    $firstname: String
    $lastname: String
    $status: PurchaseRequestStatusALL
  ) {
    PurchaseRequestList(input:{
      id: $id
      refId: $refId
      deadlineDate: $deadlineDate
      remark: $remark
      repairId: $repairId
      createdAt: $createdAt
      updatedAt: $updatedAt
      orderBy: $orderBy
      orderField: $orderField
      limit: $limit
      offset: $offset
      RepairJob: $RepairJob
      RequestBy: {
        firstname: $firstname
        lastname: $lastname
      }
      status: $status
    }) {
      lists {
        id
        refId
        deadlineDate
        remark
        repairId
        status
        Items{
          id
          inventoryOptionId
          InventoryOption{
            id
            sku
            buyPrice
            salesPrice
            isVat
            vat
            initialStock
            minimumStock
            variantName
            inventory{
              id
              sku
              reference
              barcode
              productName
              productGroup
              stockable
              stockType
              category
              brand
              initialCost
              variantAmount
              sellable
              purchasable
              taxable
              serialTracking
              status
              model
            }
            initialCost
            stockLocation{
              id
              quantity
              warehouse{
                id
                warehouseCode
              }
            }
            url
          }
          requestId
          quantity
          orderedQuantity
          createdAt
          updatedAt
        }
        RepairJob{
          id
          refId
        }
        RequestBy{
          userId
          firstname
          lastname
          telephone
          position
          Warehouses{
            id
            warehouseCode
            warehouseName
          }
        }
        createdAt
        updatedAt
      }
      totalCount
      totalFilter
    }
  }
`

export const TRUCK_TIRE_LIST = gql`
  query TruckTireList (
    $id: Int
    $createdAt: Date
    $updatedAt: Date
    $wheelNo: String
    $truckId: Int
    $orderBy: OrderBy
    $orderField: TruckTireOrderField
    $limit: Int
    $offset: Int
  ) {
    TruckTireList(input:{
      id: $id
      createdAt: $createdAt
      updatedAt: $updatedAt
      wheelNo: $wheelNo
      truckId: $truckId
      orderBy: $orderBy
      orderField: $orderField
      limit: $limit
      offset: $offset
    }) {
      lists{
        id
        wheelNo
        serialId
        truckId
        Detail{
            id
            startMileAge
            inDate
          }
        Serial{
          id
          serialNumber
          inventoryOption{
            id
            variantName
          }
          Tire{
            id
            TireType{
              id
              name
            }
          }
        }
        Truck{
          id
          plateNumber
          chassisNumber
          type{
            id
            nameTh
          }
        }
        createdAt
        updatedAt
      }
      totalCount
      totalFilter
    }
  }
`

export const TRAILER_TIRE_LIST = gql`
  query TrailerTireList (
    $id: Int
    $createdAt: Date
    $updatedAt: Date
    # $wheelNo: Int
    $trailerId: Int
    $orderBy: OrderBy
    $orderField: TrailerTireOrderField
    $limit: Int
    $offset: Int
  ) {
    TrailerTireList(input:{
      id: $id
      createdAt: $createdAt
      updatedAt: $updatedAt
      # wheelNo: $wheelNo
      trailerId: $trailerId
      orderBy: $orderBy
      orderField: $orderField
      limit: $limit
      offset: $offset
    }) {
      lists{
        id
        wheelNo
        serialId
        trailerId
        Detail{
            id
            startMileAge
            inDate
          }
        Serial{
          id
          serialNumber
          inventoryOption{
            id
            variantName
          }
          Tire{
            id
            TireType{
              id
              name
            }
          }
        }
        Trailer{
          id
          trailerPlate
          chassisNumber
          type{
            id
            nameTh
          }
        }
        createdAt
        updatedAt
      }
      totalCount
      totalFilter
    }
  }
`

export const TRUCK_TIRE_USAGE_LOG_LIST = gql`
 query TireUsedLogListForTruck(
    $truckId: Int!
 ) {
  TireUsedLogListForTruck(
    truckId: $truckId
  ) {
    lists{
      id
      serialId
      wheelNo
      Serial{
        id
        TruckTires{
          id
          wheelNo
        }
        serialNumber
        inventoryOption{
          id
          variantName
        }
        Tire{
          id
          TireType{
            id
            name
          }
        }
      }
      serviceId
      Service{
        id
        job{
          id
          Truck{
            id
            plateNumber
            type{
              id
              nameTh
            }
          }
        }
      }
      startMileAge
      endMileAge
      distance
      lifeTime
      remark
      inDate
      outDate
      createdAt
      updatedAt
    }
    totalCount
    totalFilter
  }
 }
`

export const TIRE_USED_LOG_LIST = gql`
  query TireUsedLogList(
    $serialId: Int!
  ) {
    TireUsedLogList(input:{
      serialId: $serialId
    }) {
      lists {
        id
        serialId
        Serial{
          id
          TrailerTires{
            id
            wheelNo
          }
          serialNumber
          inventoryOption{
            id
            variantName
            inventory{
              id
              brand
              supplier{
                id
                name
              }
            }
          }
          Tire{
            id
            TireType{
              id
              name
            }
          }
        }
        serviceId
        Service{
          id
          job{
            id
            Trailer{
              id
              trailerPlate
              type{
                id
                nameTh
              }
            }
          }
        }
        startMileAge
        endMileAge
        distance
        lifeTime
        remark
        inDate
        outDate
        createdAt
        updatedAt
        wheelNo
        Truck{
          id
          plateNumber
        }
        Trailer{
          id
          trailerPlate
        }
      }
      totalCount
      totalFilter
    }
  }
`

export const TRAILER_TIRE_USAGE_LOG_LIST = gql`
  query TireUsedLogListForTrailer(
    $trailerId: Int!
  ) {
    TireUsedLogListForTrailer(
      trailerId: $trailerId
    ) {
      lists{
        id
        serialId
        wheelNo
        Serial{
          id
          TrailerTires{
            id
            wheelNo
          }
          serialNumber
          inventoryOption{
            id
            variantName
          }
          Tire{
            id
            TireType{
              id
              name
            }
          }
        }
        serviceId
        Service{
          id
          job{
            id
            Trailer{
              id
              trailerPlate
              type{
                id
                nameTh
              }
            }
          }
        }
        startMileAge
        endMileAge
        distance
        lifeTime
        remark
        inDate
        outDate
        createdAt
        updatedAt
      }
      totalCount
      totalFilter
    }
  }
`

export const TIRE_PATCH_TYPE_LIST = gql`
  query TirePatchLogTypeList {
    TirePatchLogTypeList {
      data
    }
  }
`

export const TIRE_PATCH_INFO = gql`
  query TirePatchLogInfo(
    $id: String
  ) {
    TirePatchLogInfo(
      id: $id
    ) {
      id
      description
      patchDate
      price
      status
      refId
      Driver{
        id
        fullname
      }
      Serial{
        id
        serialNumber
        inventoryOption{
          id
          variantName
        }
      }
      type
      rejectReason
      files{
        id
        url
        filename
      }
      TirePatchStore{
        id
        name
        phoneNumber
        address
        taxId
      }
      paidDate
      totalPaid
      Truck{
        id
        plateNumber
      }
      Trailer{
        id
        trailerPlate
      }
      createdAt
      updatedAt
    }
  }
`

export const PURCHASE_REQUISITION_INFO = gql`
  query PurchaseRequestInfo(
    $id: String
  ) {
    PurchaseRequestInfo(
      id: $id
    ) {
      id
      refId
      deadlineDate
      remark
      repairId
      supplierId
      department
      status
      Items{
        id
        inventoryOptionId
        requestId
        quantity
        orderedQuantity
        remark
        InventoryOption {
          id
          sku
          variantName
          buyPrice
          inventory {
            id
            productName
            sku
          }
          stockLocation {
            id
            quantity
            preorderItemQuantity
            warehouse {
              id
              warehouseName
              warehouseCode
            }
          }
        }
      }
      RepairJob{
        id
        refId
      }
      RequestBy{
       userId
       firstname
       lastname
      }
      createdAt
      updatedAt
    }
  }
`

export const USERS = gql`
  query userList(
    $limit: Int
    $offset: Int
    $name: String
    $status: Status
    $orderField: UserOrderField
    $orderBy: OrderBy
  ) {
    userList(input: {
      limit: $limit
      offset: $offset
      name: $name
      status: $status
      orderField: $orderField
      orderBy: $orderBy
    }) {
      data {
        list {
          id
          firstName
          lastName
          email
          roles {
            id
            name
            description
            permissions { 
              id
              name
              description
            }
          }
          username
          createdAt
          updatedAt
        }
        total
      }
    }
  }
`

export const ROLES = gql`
  query roleList(
    $limit: Int
    $offset: Int
    $name: String
  ) {
    roleList(input: {
      limit: $limit
      offset: $offset
      name: $name
    }) {
      data {
        list {
          id
          name
          description
            permissions { 
              id
              name
              description
            }
          createdAt
          updatedAt
        }
        total
      }
    }
  }
`

export const BANKS = gql`
  query bankList{
    bankList {
      data {
        list {
          id
          code
          name
          status
          createdAt
          updatedAt
        }
        total
      }
    }
  }
`

export const PRICINGTYPES = gql`
  query pricingTypeList{
    pricingTypeList {
      data {
        list {
          id
          code
          name
          type
          status
          discount
          createdAt
          updatedAt
        }
        total
      }
    }
  }
`

export const MYINFO = gql`
  query myInfo {
    myInfo {
      userId
      email
      firstname
      lastname
      telephone
      position
      profileImage
      driverId
      Roles{
        id
        name
      }
      status
      createdAt
      updatedAt
      Warehouses{
        id
        warehouseCode
        warehouseName
      }
      Customer{
        id
        companyName
      }
    }
  }
`

export const WAREHOUSES = gql`
  query warehouseList(
    $limit: Int
    $offset: Int
    $warehouseCode: String
    $warehouseName: String
    $district: String
    $orderField: WarehouseOrderField
    $orderBy: OrderBy
  ) {
    warehouseList (input: {
      limit: $limit
      offset: $offset
      warehouseCode: $warehouseCode
      warehouseName: $warehouseName
      orderField: $orderField
      orderBy: $orderBy
      address: {
        district: $district
      }
    }) {
      data {
        list {
          id
          warehouseCode
          warehouseName
          address {
            addressNo
            supplierId
            type
            province
            district
            subDistrict
            postcode
            contactName
            contactPhoneNumber
            contactFaxNumber
            contactEmail
            contactRemark
          }
        }
        total
      }
    }
  }
`

export const SUPPLIERS = gql`
  query supplierList(
    $limit: Int
    $offset: Int
    $name: String
    $orderField: SupplierOrderField
    $orderBy: OrderBy
    # $prefix: String
    # $contactOfficeTel: String
    $officeTel: String
    $contactName: String
    $contactPhoneNumber: String
  ) {
    supplierList(input: {
      limit: $limit
      offset: $offset
      name: $name
      orderField: $orderField
      orderBy: $orderBy
      # prefix: $prefix
      contactName: $contactName
      # address: {
      #   contactOfficeTel: $contactOfficeTel
      # }
      officeTel: $officeTel
      contactPhoneNumber: $contactPhoneNumber
    }) {
      data {
        list {
          id
          paymentType
          # prefix
          name
          taxId
          contactAddress{
            contactOfficeTel
          }
          # bankAccountName
          # bankAccountNumber
          # bank {
          #   id
          #   code
          #   name
          #   status
          # }
          isVat
          contactName
          contactPhoneNumber
          contactFaxNumber
          contactEmail
          contactLineId
          contactFacebookName
          contactRemark
          officeTel
          status
          createdAt
          updatedAt
        }
        total
        # totalFilter
      }
    }
  }
`

export const PURCHASEORDER = gql`
  query PurchaseOrderInfo (
    $id: String
  ) {
    PurchaseOrderInfo (
      id: $id
    ) {
      id
      number
      extRef
      status
      dueDate
      supplierId
      discountType
      discount
      paymentType
      creditDueDate
      remark
      deliveryCost
      warehouseId
      withholdingTaxId
      companyType
      paymentDueDate
      vatType
      Warehouse{
        warehouseCode
        warehouseName
        id
      }
      Supplier{
        id
        name
      }
      WithholdingTax{
        id
        value
        createdAt
        updatedAt
      }
      OrderItems{
        id
        inventoryOptionId
        supplierId
        status
        buyPrice
        salesPrice
        quantity
        expectedReceivedDate
        overdueDate
        purchaseOrderId
        isVat
        vat
        isSerialTracking
        discount
        createdAt
        updatedAt
        InventoryOption{
          id
          sku
          buyPrice
          salesPrice
          isVat
          vat
          initialStock
          minimumStock
          variantName
          inventory{
            id
            sku
            reference
            barcode
            productName
            productGroup
            stockable
            stockType
            category
            brand
          }
          initialCost
          stockLocation{
            id
            row
            shelf
            quantity
            warehouse{
              warehouseCode
              warehouseName
              id
            }
          }
        }
        PRItem{
          id
          requestId
          quantity
          orderedQuantity
          PurchaseRequest{
            id
            refId
            deadlineDate
            remark
            repairId
            status
            RequestBy{
              userId
              firstname
              lastname
            }
            createdAt
            updatedAt
          }
        }
      }
      files{
        id
        purchaseOrderId
        fileName
        url
      }
      createdAt
      updatedAt
      purchaseDate
    }
  }
`

export const GOOD_RECEIVED_INFO = gql`
  query GoodReceiveInfo (
    $id: String
  ) {
    GoodReceiveInfo(
      id:$id
    ) {
      id
      refId
      supplierRefId
      remark
      purchaseorderId
      PurchaseOrder{
        id
        number
      }
      warehouseId
      Warehouse{
        warehouseCode
        warehouseName
        id
      }
      supplierId
      Supplier{
        id
        name
      }
      createdBy
      User{
        userId
        firstname
        lastname
      }
      GoodReceiveFiles{
        id
        url
        filename
      }
      GoodReceiveItem{
        id
        inventoryOptionId
        orderItemId
        quantity
        price
        isExtra
        discount
        goodreceiveId
        InventoryOption{
            id
            inventory{
              id
              productName
              sku
              brand
            }
          }
        OrderItem{
          id
          inventoryOptionId
          supplierId
          status
          buyPrice
          salesPrice
          quantity
          expectedReceivedDate
          overdueDate
          purchaseOrderId
          isVat
          vat
          isSerialTracking
          discount
          createdAt
          updatedAt
          InventoryOption{
            id
            inventory{
              id
              productName
              sku
              brand
            }
          }
          # PRItem
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`

export const TIRE_GOOD_RECEIVED_INFO = gql`
  query GoodReceiveTireInfo (
    $id: String
  ) {
    GoodReceiveTireInfo(
      id:$id
    ) {
      id
      refId
      supplierRefId
      remark
      purchaseorderId
      PurchaseOrder{
        id
        number
      }
      warehouseId
      Warehouse{
        warehouseCode
        warehouseName
        id
      }
      supplierId
      Supplier{
        id
        name
      }
      createdBy
      User{
        userId
        firstname
        lastname
      }
      GoodReceiveTireFiles{
        id
        url
        filename
      }
      GoodReceiveTireItem{
        id
        inventoryOptionId
        orderItemId
        quantity
        price
        isExtra
        discount
        goodreceiveTireId
        serials{
          id
          serialNumber
        }
        InventoryOption{
            id
            inventory{
              id
              productName
              sku
              brand
            }
          }
        OrderItem{
          id
          inventoryOptionId
          supplierId
          status
          buyPrice
          salesPrice
          quantity
          expectedReceivedDate
          overdueDate
          purchaseOrderId
          isVat
          vat
          isSerialTracking
          discount
          createdAt
          updatedAt
          InventoryOption{
            id
            inventory{
              id
              productName
              sku
              brand
            }
          }
          # PRItem
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`

export const PURCHASEORDERS = gql`
  query PurchaseOrderList (
    $id: Int
    $number: String
    $createdAt: Date
    $updatedAt: Date
    $orderBy: OrderBy
    $orderField: PurchaseOrderOrderField
    $limit: Int
    $offset: Int
    $status: FilterPurchaseOrderStatus
    $Supplier: FilterSupplierInPurchaseOrder
  ) {
    PurchaseOrderList (
      input: {
        id: $id
        number: $number
        createdAt: $createdAt
        updatedAt: $updatedAt
        orderBy: $orderBy
        orderField: $orderField
        status: $status
        limit: $limit
        offset: $offset
        Supplier: $Supplier
      }
    ) {
      lists{
        id
        number
        status
        dueDate
        createdAt
        supplierId
        warehouseId
        Warehouse{
          warehouseCode
          warehouseName
          id
        }
        Supplier{
          id
          name
        }
      }
      totalCount
      totalFilter
    }
  }
`

export const PURCHASE_ORDER_LIST_FOR_GR = gql`
  query PurchaseOrderListForGoodReceive(
    $number: String
    $id: Int
    $status: FilterPurchaseOrderStatus
    $Supplier: FilterSupplierInPurchaseOrder
    $Inventory: FilterInventoryInPurchaseOrder
    $createdAt: Date
    $updatedAt: Date
    $orderBy: OrderBy
    $orderField: PurchaseOrderOrderField
    $limit: Int
    $offset: Int
  ) {
    PurchaseOrderListForGoodReceive(input:{
      number: $number
      id: $id
      status: $status
      Supplier: $Supplier
      Inventory: $Inventory
      createdAt: $createdAt
      updatedAt: $updatedAt
      orderBy: $orderBy
      orderField: $orderField
      limit: $limit
      offset: $offset
    }) {
      lists{
        id
        number
        extRef
        status
        dueDate
        supplierId
        discountType
        discount
        paymentType
        creditDueDate
        remark
        deliveryCost
        warehouseId
        withholdingTaxId
        Warehouse{
          warehouseCode
          warehouseName
          id
        }
        Supplier{
          id
          name
        }
        OrderItems{
          id
          inventoryOptionId
          supplierId
          status
          buyPrice
          salesPrice
          receivedQuantity
          quantity
          expectedReceivedDate
          overdueDate
          purchaseOrderId
          isSerialTracking
          discount
          createdAt
          updatedAt
          InventoryOption{
            id
            sku
            buyPrice
            salesPrice
            initialStock
            minimumStock
            variantName
            inventory{
              id
              sku
              reference
              barcode
              productName
              productGroup
              stockable
              stockType
              category
              brand
              unit
            }
            initialCost
            url
          }
          PRItem{
            id
          }
        }
      }
      totalCount
      totalFilter
    }
  }
`

export const GOOD_RECEIVED_LIST = gql`
  query GoodReceiveList(
    $id: Int
    $refId: String
    $supplierRefId: String
    $Supplier: FilterSupplierInGoodReceive
    $PurchaseOrder: FilterPurchaseOrderInGoodReceive
    $firstname: String
    $lastname: String
    $createdAt: Date
    $updatedAt: Date
    $orderBy: OrderBy
    $orderField: GoodReceiveOrderField
    $limit: Int
    $offset: Int
  ) {
    GoodReceiveList(input:{
      id: $id
      refId: $refId
      supplierRefId: $supplierRefId
      Supplier: $Supplier
      PurchaseOrder: $PurchaseOrder
      User:{
        firstname: $firstname
        lastname: $lastname
      }
      createdAt: $createdAt
      updatedAt: $updatedAt
      orderBy: $orderBy
      orderField: $orderField
      limit: $limit
      offset: $offset
    }) {
      lists{
        id
        refId
        supplierRefId
        remark
        purchaseorderId
        PurchaseOrder{
          id
          number
        }
        warehouseId
        Warehouse{
          warehouseCode
          warehouseName
          id
        }
        supplierId
        Supplier{
          id
          name
        }
        createdBy
        User{
          userId
          firstname
          lastname
        }
        createdAt
        updatedAt
      }
      totalCount
      totalFilter
    }
  }
`

export const TIRE_GOOD_RECEIVED_LIST = gql`
  query GoodReceiveTireList(
    $id: Int
    $refId: String
    $supplierRefId: String
    $Supplier: FilterSupplierInGoodReceiveTire
    $PurchaseOrder: FilterPurchaseOrderInGoodReceiveTire
    $firstname: String
    $lastname: String
    $createdAt: Date
    $updatedAt: Date
    $orderBy: OrderBy
    $orderField: GoodReceiveTireOrderField
    $limit: Int
    $offset: Int
    $serialNumber: String
  ) {
    GoodReceiveTireList(input:{
      id: $id
      refId: $refId
      supplierRefId: $supplierRefId
      Supplier: $Supplier
      PurchaseOrder: $PurchaseOrder
      User:{
        firstname: $firstname
        lastname: $lastname
      }
      createdAt: $createdAt
      updatedAt: $updatedAt
      orderBy: $orderBy
      orderField: $orderField
      limit: $limit
      offset: $offset
      serialNumber: $serialNumber
    }) {
      lists{
        id
        refId
        supplierRefId
        remark
        purchaseorderId
        PurchaseOrder{
          id
          number
        }
        warehouseId
        Warehouse{
          warehouseCode
          warehouseName
          id
        }
        supplierId
        Supplier{
          id
          name
        }
        createdBy
        User{
          userId
          firstname
          lastname
        }
        createdAt
        updatedAt
      }
      totalCount
      totalFilter
    }
  }
`

export const CUSTOMERS = gql`
  query customerList(
    $limit: Int
    $offset: Int
    $name: String
    $orderField: CustomerOrderField
    $orderBy: OrderBy
  ) {
    customerList(input: {
      limit: $limit
      offset: $offset
      name: $name
      orderField: $orderField
      orderBy: $orderBy
    }) {
      data {
        list {
          id
          paymentType
          pricingType {
            id
            code
            name
            type
            status
            discount
          }
          # prefix
          name
          taxId
          bankAccountName
          bankAccountNumber
          bank {
            id
            code
            name
            status
          }
          isVat
          contactName
          contactPhoneNumber
          contactFaxNumber
          contactEmail
          contactLineId
          contactFacebookName
          contactRemark
          creditLimit
          creditUsage
          creditTerm
          status
          createdAt
          updatedAt
        }
        total
      }
    }
  }
`

export const GET_PO_STATUS = gql`
  query getPOStatusList {
    getPOStatusList {
      success
      message
      data
    }
  }
`

export const CATEGORIES = gql`
  query getCategoryList {
    getCategoryList {
      data
    }
  }
`

export const BRANDS = gql`
  query getBrandList {
    getBrandList {
      data
    }
  }
`

export const WAREHOUSE = gql`
  query findWarehouse(
    $id: Int
  ) {
    findWarehouse(id: $id) {
      data {
        address {
          addressNo
          province
          district
          subDistrict
          postcode
          contactName
          contactPhoneNumber
          contactFaxNumber
          contactEmail
          contactRemark
        }
        warehouseCode
        warehouseName
      }
    }
  }
`

export const USER = gql`
  query userDetail(
    $id: Int!
  ) {
    userDetail(id: $id) {
      data {
        id
        firstName
        lastName
        email
        roles {
          id
          name
          description
          permissions { 
            id
            name
            description
          }
        }
        username
        createdAt
        updatedAt
      }
    }
  }
`

export const SUPPLIER = gql`
  query supplierDetail(
    $id: Int!
  ) {
    supplierDetail(id: $id) {
      data {
        id
        paymentType
        # pricingType {
        #   id
        #   code
        #   name
        #   type
        #   status
        #   discount
        # }
        # prefix
        name
        taxId
        # bankAccountName
        # bankAccountNumber
        paymentInfo {
          id
          bankId
          bankAccountName
          bankAccountNumber
          bankAccountType
        }
        officeTel
        isVat
        # type
        # creditLimit
        creditTerm
        # creditUsage
        contactName
        addressUrl
        contactAddress {
          contactOfficeTel
        }
        contactPhoneNumber
        contactFaxNumber
        contactEmail
        contactLineId
        # contactFacebookName
        contactRemark
        status
        createdAt
        updatedAt
      }
    }
  }
`

export const CUSTOMER = gql`
  query customerDetail(
    $id: Int!
  ) {
    customerDetail(id: $id) {
      data {
        id
        paymentType
        pricingType {
          id
          code
          name
          type
          status
          discount
        }
        # prefix
        name
        taxId
        bankAccountName
        bankAccountNumber
        bank {
          id
          code
          name
          status
        }
        isVat
        contactName
        contactPhoneNumber
        contactFaxNumber
        contactEmail
        contactLineId
        contactFacebookName
        contactRemark
        creditLimit
        creditUsage
        creditTerm
        status
        createdAt
        updatedAt
      }
    }
  }
`

export const INVENTORIES = gql`
  query inventoryList(
    $limit: Int
    $offset: Int
    $sku: String
    $productName: String
    $productGroup: FilterProductGroup
    $category: String
    $brand: String
    $supplierName: String
    $variantName: String
    $lowStock: Boolean
    $supplierId: Int
  ) {
    inventoryList(input: {
      limit: $limit
      offset: $offset
      sku: $sku
      productName: $productName
      productGroup: $productGroup
      category: $category
      brand: $brand
      supplier: {
        name: $supplierName
      }
      inventoryOptions: {
        variantName: $variantName
      }
      lowStock: $lowStock
      supplierId: $supplierId
    }) {
      data {
        lowStockCount
        totalCount
        totalFilter
        list {
          id
          sku
          reference
          barcode
          productName
          productGroup
          stockable
          stockType
          category
          brand
          initialCost
          sellable
          purchasable
          taxable
          serialTracking
          status
          supplier {
            id
            name
          }
          tag {
            id
            name
          }
          inventoryOptions {
            id
            sku
            buyPrice
            salesPrice
            isVat
            vat
            variantName
            option1 {
              id
              optionKey
              optionName
            }
            option2 {
              id
              optionKey
              optionName
            }
            option3 {
              id
              optionKey
              optionName
            }
            initialStock
            minimumStock
            pack {
              id
              name
              quantity
              salesPrice
            }
            stockLocation {
              id
              row
              shelf
              quantity
              preorderItemQuantity
              warehouse {
                id
                warehouseCode
                warehouseName
                address {
                  id
                  supplierId
                  customerId
                  type
                  addressNo
                  province
                  district
                  subDistrict
                  postcode
                  contactName
                  contactOfficeTel
                  contactPhoneNumber
                  contactFaxNumber
                  contactEmail
                  contactRemark
                }
              }
            }
            url
          }
        }
      }
      success
      message
    }
  }
`

export const INVENTORYLOG = gql`
  query InventoryLogList(
    $inventoryOptionId: Int
    $name: String
    $createdAt: Date
    $updatedAt: Date
    $orderBy: OrderBy
    $orderField: InventoryLogOrderField
    $limit: Int
    $offset: Int
    $warehouseId: Int
  ) {
    InventoryLogList(input:{
      inventoryOptionId: $inventoryOptionId
      name: $name
      createdAt: $createdAt
      updatedAt: $updatedAt
      orderBy: $orderBy
      orderField: $orderField
      limit: $limit
      offset: $offset
      warehouseId: $warehouseId
    }) {
      lists{
        id
        inventoryOptionId
        warehouseId
        type
        refId
        oldQuantity
        newQuantity
        quantity
        remark
        createdAt
        updatedAt
        Warehouse{
          warehouseCode
          warehouseName
          id
        }
      }
      totalCount
      totalFilter
    }
  }
`

export const TIRE_INVENTORYLOG = gql`
  query TransferTireSerialList(
    $inventoryOptionId: Int
    $oldwarehouseId: Int
    $warehouseId: Int
    $createdAt: Date
    $updatedAt: Date
    $orderBy: OrderBy
    $orderField: TransferTireSerialOrderField
    $limit: Int
    $offset: Int
  ) {
    TransferTireSerialList(input:{
      inventoryOptionId: $inventoryOptionId
      oldwarehouseId: $oldwarehouseId
      warehouseId: $warehouseId
      createdAt: $createdAt
      updatedAt: $updatedAt
      orderBy: $orderBy
      orderField: $orderField
      limit: $limit
      offset: $offset
    }) {
      lists{
        id
        CurrentSerialWarehouse{
          id
          warehouseName
        }
        PreviousSerialWarehouse{
          id
          warehouseName
        }
        # InventoryOption
        TransferedSerials{
          id
          serialNumber
        }
        createdAt
        updatedAt
      }
      totalCount
      totalFilter
    }
  }
`

export const INVENTORIESPO = gql`
  query normalInventoryListforPO(
    $limit: Int
    $offset: Int
    $sku: String
    $productName: String
    $productGroup: FilterProductGroup
    $category: String
    $brand: String
    $supplierName: String
    $supplierId: Int
    $variantName: String
  ) {
    normalInventoryListforPO(input: {
      limit: $limit
      offset: $offset
      sku: $sku
      productName: $productName
      productGroup: $productGroup
      category: $category
      brand: $brand
      supplier: {
        name: $supplierName
      }
      supplierId: $supplierId
      inventoryOptions: {
        variantName: $variantName
      }
    }) {
      data {
        list {
          id
          sku
          reference
          barcode
          productName
          productGroup
          stockable
          stockType
          category
          brand
          initialCost
          sellable
          purchasable
          taxable
          serialTracking
          status
          unit
          supplier {
            id
            name
          }
          tag {
            id
            name
          }
          inventoryOptions {
            id
            sku
            buyPrice
            salesPrice
            isVat
            vat
            variantName
            option1 {
              id
              optionKey
              optionName
            }
            option2 {
              id
              optionKey
              optionName
            }
            option3 {
              id
              optionKey
              optionName
            }
            initialStock
            minimumStock
            pack {
              id
              name
              quantity
              salesPrice
            }
            stockLocation {
              id
              row
              shelf
              quantity
              warehouse {
                id
                warehouseCode
                warehouseName
                address {
                  id
                  supplierId
                  customerId
                  type
                  addressNo
                  province
                  district
                  subDistrict
                  postcode
                  contactName
                  contactOfficeTel
                  contactPhoneNumber
                  contactFaxNumber
                  contactEmail
                  contactRemark
                }
              }
            }
            url
          }
        }
        total
      }
      success
      message
    }
  }
`

export const LOWINVENTORIESPO = gql`
  query lowInventoryListforPO(
    $limit: Int
    $offset: Int
    $sku: String
    $productName: String
    $productGroup: FilterProductGroup
    $category: String
    $brand: String
    $supplierName: String
    $variantName: String
    $supplierId: Int
  ) {
    lowInventoryListforPO(input: {
      limit: $limit
      offset: $offset
      sku: $sku
      productName: $productName
      productGroup: $productGroup
      category: $category
      brand: $brand
      supplier: {
        name: $supplierName
      }
      supplierId: $supplierId
      inventoryOptions: {
        variantName: $variantName
      }
    }) {
      data {
        list {
          id
          sku
          reference
          barcode
          productName
          productGroup
          stockable
          stockType
          category
          brand
          initialCost
          sellable
          purchasable
          taxable
          serialTracking
          status
          unit
          supplier {
            id
            name
          }
          tag {
            id
            name
          }
          inventoryOptions {
            id
            sku
            buyPrice
            salesPrice
            isVat
            vat
            variantName
            option1 {
              id
              optionKey
              optionName
            }
            option2 {
              id
              optionKey
              optionName
            }
            option3 {
              id
              optionKey
              optionName
            }
            initialStock
            minimumStock
            pack {
              id
              name
              quantity
              salesPrice
            }
            stockLocation {
              id
              row
              shelf
              quantity
              warehouse {
                id
                warehouseCode
                warehouseName
                address {
                  id
                  supplierId
                  customerId
                  type
                  addressNo
                  province
                  district
                  subDistrict
                  postcode
                  contactName
                  contactOfficeTel
                  contactPhoneNumber
                  contactFaxNumber
                  contactEmail
                  contactRemark
                }
              }
            }
            url
          }
        }
        total
      }
      success
      message
    }
  }
`

export const TIRE_INVENTORIES = gql`
  query TireList(
    $limit: Int
    $offset: Int
    $sku: String
    $autocompleteKey: String
    $productName: String
    # $productGroup: FilterProductGroup
    # $category: String
    $brand: String
    $supplierName: String
    # $variantName: String
    $tireTypeName: String
    $model: String
    $serials: String
    $width: String
    $rims: String
    $series: String
    $lowStock: Boolean
    $supplierId: Int
  ) {
    TireList(input: {
      limit: $limit
      supplierId: $supplierId
      offset: $offset
      inventory: {
        sku: $sku
        productName: $productName
        brand: $brand
        model: $model
      }
      autocompleteKey: $autocompleteKey
      serials: {
        serialNumber: $serials
      }
      # productGroup: $productGroup
      # category: $category
      supplier: {
        name: $supplierName
      }
      # inventoryOptions: {
      # variantName: $variantName
      # }
      TireType: {
        name: $tireTypeName
      }
      optionWidth: $width
      rims: $rims
      series: $series
      lowStock: $lowStock
    }) {
        lists {
          id
          sku
          status
          stockType
          productName
          brand
          supplier {
              id
              name
            }
          Tire{
            TireType{
              id
              name
            }
            inventory {
            id
            sku
            reference
            barcode
            productName
            productGroup
            stockable
            stockType
            category
            brand
            initialCost
            sellable
            purchasable
            model
            taxable
            serialTracking
            status
            supplier {
              id
              name
            }
            tag {
              id
              name
            }
          }
          }
          # serials{
          #   id
          #   width
          #   series
          #   rims
          #   status
          #   # tire
          #   serialNumber
          # }
          inventoryOptions {
            id
            sku
            buyPrice
            salesPrice
            isVat
            vat
            variantName
            option1 {
              id
              optionKey
              optionName
            }
            option2 {
              id
              optionKey
              optionName
            }
            option3 {
              id
              optionKey
              optionName
            }
            initialStock
            minimumStock
            pack {
              id
              name
              quantity
              salesPrice
            }
            stockLocation {
              id
              row
              shelf
              quantity
              warehouse {
                id
                warehouseCode
                warehouseName
                address {
                  id
                  supplierId
                  customerId
                  type
                  addressNo
                  province
                  district
                  subDistrict
                  postcode
                  contactName
                  contactOfficeTel
                  contactPhoneNumber
                  contactFaxNumber
                  contactEmail
                  contactRemark
                }
              }
            }
            url
          }
        }
        lowStockCount
        totalCount
        totalFilter
      }
  }
`

export const TIRE_SERIAL_NUMBER_LIST = gql`
  query TireSerialNumberList(
    $serialNumber: String
    $status: FilterTireSerialNumberStatus
    $limit: Int
    $offset: Int
    $inventoryOptionId: Int
    $plateNumber: String
    $trailerPlate: String
    $warehouseId: Int
  ) {
    TireSerialNumberList(input: {
      serialNumber: $serialNumber
      status: $status
      limit: $limit
      offset: $offset
      inventoryOptionId: $inventoryOptionId
      Truck: {
        plateNumber: $plateNumber
      }
      Trailer: {
        trailerPlate: $trailerPlate
      }
      warehouseId: $warehouseId
    }) {
      totalCount
      totalFilter
      lists{
        id
        status
        serialNumber
        lostReason
        inventoryOption{
          id
          variantName
          inventory{
            id
            brand
          }
        }
        TruckTires{
          wheelNo
          Truck{
            plateNumber
            type{
              nameTh
            }
          }
        }
        TrailerTires{
          wheelNo
          Trailer{
            trailerPlate
            type{
              nameTh
            }
          }
        }
        Warehouse{
          id
          warehouseName
        }
        createdAt
      }
    }
  }
`

export const TIRETYPES = gql`
  query TireTypeList(
    $id: Int
    $name: String
    $createdAt: Date
    $updatedAt: Date
    $orderBy: OrderBy
    $orderField: TireTypeOrderField
    $limit: Int
    $offset: Int
  ) {
    TireTypeList(input: {
      id: $id
      name: $name
      createdAt: $createdAt
      updatedAt: $updatedAt
      orderBy: $orderBy
      orderField: $orderField
      limit: $limit
      offset: $offset
    }) {
      lists{
        id
        name
        createdAt
        updatedAt
      }
      totalCount
      totalFilter
    }
  }
`

export const SALE_ORDERS = gql`
  query salesOrderList(
    $limit: Int
    $offset: Int
    $search: String
    $status: SalesOrderStatus
    $startCreatedDate: Date
    $endCreatedDate: Date
    $startDueDate: Date
    $endDueDate: Date
  ) {
    salesOrderList(input: {
      limit: $limit
      offset: $offset
      search: $search
      status: $status
      startCreatedDate: $startCreatedDate
      endCreatedDate: $endCreatedDate
      startDueDate: $startDueDate
      endDueDate: $endDueDate
    }) {
      data {
        list {
          id
          soNumber
          status
          dueDate
          type
          creditDueDate
          warrantyExpireDate
          remarks
          subtotal
          discountAmount
          subtotalAfterDiscount
          vatAmount
          orderItems {
            id
            status
            buyPrice
            salesPrice
            quantity
            expectedReceivedDate
            overdueDate
            isVat
            vat
            isSerialTracking
            serialNumbers {
              id
              serial
              createdAt
              updatedAt
            }
            inventoryOption {
              id
              sku
              variantName
              buyPrice
              salesPrice
              isVat
              vat
              option1 {
                id
                optionKey
                optionName
              }
              option2 {
                id
                optionKey
                optionName
              }
              option3 {
                id
                optionKey
                optionName
              }
              initialStock
              minimumStock
              pack {
                id
                name
                quantity
              }
              stockLocation {
                id
                row
                shelf
                quantity
                warehouse {
                  warehouseCode
                  warehouseName
                  address {
                    id
                  }
                  id
                }
              }
              url
            }
            purchaseOrder {
              id
              number
              extRef
              status
              dueDate
              paymentType
              creditDueDate
              remark
              discountType
              discount
              supplier {
                id
                name
              }
              withholdingTax {
                id
                value
                createdAt
                updatedAt
              }
              purchaseOrderFiles {
                id
                fileName
                url
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          salesOrderFiles {
            id
            fileName
            url
            createdAt
            updatedAt
          }
          customer {
            id
            paymentType
            pricingType {
              id
              code
              name
              type
              status
              discount
              createdAt
              updatedAt
            }
            # prefix
            name
            taxId
            bankAccountName
            bankAccountNumber
            bank {
              id
              code
              name
              status
              createdAt
              updatedAt
            }
            address {
              id
              supplierId
              customerId
              type
              addressNo
              province
              district
              subDistrict
              postcode
              contactName
              contactOfficeTel
              contactPhoneNumber
              contactFaxNumber
              contactEmail
              contactRemark
            }
            isVat
            contactName
            contactPhoneNumber
            contactFaxNumber
            contactEmail
            contactLineId
            contactFacebookName
            contactRemark
            creditLimit
            creditUsage
            creditTerm
            status
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        total
      }
    }
  }
`

export const GET_OPTIONS = gql`
  query getOptions {
    getOptions {
      data {
        optionKey
        optionNames
      }
    }
  }
`

export const GET_TAGS = gql`
  query getTagList {
    getTagList {
      data
    }
  }
`

export const INVENTORY = gql`
  query inventoryInfo(
    $id: Int
  ) {
    inventoryInfo(id: $id) {
      data {
        id
        sku
        # type
        reference
        barcode
        productName
        productGroup
        stockType
        category
        brand
        sellable
        purchasable
        taxable
        serialTracking
        status
        technicianName
        unit
        supplier {
          id
          name
        }
        tag {
          id
          name
        }
        inventoryOptions {
          # item {
            id
            sku
            buyPrice
            salesPrice
            isVat
            vat
            variantName
            option1 {
              id
              optionKey
              optionName
            }
            option2 {
              id
              optionKey
              optionName
            }
            option3 {
              id
              optionKey
              optionName
            }
            initialStock
            initialCost
            minimumStock
            pack {
              id
              name
              quantity
              salesPrice
            }
            stockLocation {
              id
              row
              shelf
              quantity
              preorderItemQuantity
              # totalStock
              # soldStock
              # toBeStocked
              # preordered
              warehouse {
                id
                warehouseCode
                warehouseName
                address {
                  id
                  supplierId
                  customerId
                  type
                  addressNo
                  province
                  district
                  subDistrict
                  postcode
                  contactName
                  contactOfficeTel
                  contactPhoneNumber
                  contactFaxNumber
                  contactEmail
                  contactRemark
                }
              }
            }
            url
          # }
          # stockQuantity {
          #   totalStock
          #   soldStock
          #   toBeStocked
          #   preordered
          # }
        }
      }
      success
      message
    }
  }
`

export const TIRE_SERIAL_NUMBER_INFO = gql`
  query TireSerialNumberInfo($id: String) {
    TireSerialNumberInfo(id: $id){
      id
      status
      Tire{
        id
        inventory{
          id
          productName
          brand
        }
        TireType{
          id
          name
        }
      }
      TruckTires{
        id
        Truck{
          plateNumber
          trailerNumber1
        }
      }
      TrailerTires{
        id
        Trailer{
          trailerPlate
        }
      }
      inventoryOption{
        id
        sku
        buyPrice
        salesPrice
        isVat
        vat
        # option1
        # option2
        # option3
        initialStock
        minimumStock
        variantName
        inventory{
          id
          productName
          brand
        }
        initialCost
        # pack
        # stockLocation
        url
      }
      serialNumber
      warehouseId
      Warehouse{
        warehouseCode
        warehouseName
        # address
        id
      }
      price
      createdAt
      updatedAt
      # Patchlogs
      lostReason
    }
  }
`

export const TIRE_SERIAL_NUMBER_INFO_FOR_TIRE_PATCH_LOG = gql`
  query TireSerialNumberInfoForTirePatchLog(
    $id: String!,
    $patchDate: Date
  ) {
    TireSerialNumberInfoForTirePatchLog(input:{
      id: $id,
      patchDate: $patchDate
      }){
      id
      status
      Tire{
        id
        inventory{
          id
          productName
          brand
        }
        TireType{
          id
          name
        }
      }
      TruckTires{
        id
        Truck{
          id
          plateNumber
          trailer{
            id
            trailerPlate
          }
        }
      }
      TrailerTires{
        id
        Trailer{
          id
          trailerPlate
          truck{
            id
            plateNumber
          }
        }
      }
      inventoryOption{
        id
        sku
        buyPrice
        salesPrice
        isVat
        vat
        # option1
        # option2
        # option3
        initialStock
        minimumStock
        variantName
        inventory{
          id
          productName
          brand
        }
        initialCost
        # pack
        # stockLocation
        url
      }
      serialNumber
      warehouseId
      Warehouse{
        warehouseCode
        warehouseName
        # address
        id
      }
      price
      createdAt
      updatedAt
      # Patchlogs
      lostReason
    }
  }
`

export const TIRE_INVENTORY = gql`
  query TireInfo($id: String) {
    TireInfo(id: $id) {
      id
      sku
      reference
      barcode
      productName
      productGroup
      stockable
      stockType
      category
      brand
      initialCost
      variantAmount
      sellable
      purchasable
      taxable
      serialTracking
      status
      technicianName
      unit
      supplier{
        id
        name
      }
      Tire{
        TireType{
          id
          name
        }
      }
      inventoryOptions {
            # item {
              id
              sku
              buyPrice
              salesPrice
              isVat
              vat
              variantName
              option1 {
              id
              optionKey
              optionName
            }
            option2 {
              id
              optionKey
              optionName
            }
            option3 {
              id
              optionKey
              optionName
            }
            initialStock
            initialCost
            minimumStock
            # serials{
            #   id
            #   status
            #   warehouseId
            #   Warehouse{
            #     warehouseName
            #   }
            #   price
            # }
            pack {
              id
              name
              quantity
              salesPrice
            }
            stockLocation {
              id
              row
              shelf
              quantity
              isNewstock
              isUsing
              isOldstock
              isWaitforsale
              isSold
              isLost
              # totalStock
              # soldStock
              # toBeStocked
              # preordered
              warehouse {
                id
                warehouseCode
                warehouseName
                address {
                  id
                  supplierId
                  customerId
                  type
                  addressNo
                  province
                  district
                  subDistrict
                  postcode
                  contactName
                  contactOfficeTel
                  contactPhoneNumber
                  contactFaxNumber
                  contactEmail
                  contactRemark
                }
              }
            }
            url
          # }
          # stockQuantity {
          #   totalStock
          #   soldStock
          #   toBeStocked
          #   preordered
          # }
        }
      model
    } 
  }
`

export const VARIANTOPTIONSKEY = gql`
  query getOptionKey {
    getOptionKey {
      data
    }
  }
`
